$(function () {
    $('ul.products').uniformify({
        selector: '.product .header h3'
    });
});
